import { Routes } from '@/constants';
import { PageHref } from '@/lib/routesMetadata';
import { Organization } from '@/server/services/Auth0/Auth0.types';

export class OrganizationModel {
  id: Organization['id'];
  displayName: Organization['display_name'];
  pages: PageHref[];
  metadata: Organization['metadata'];
  branding: Organization['branding'];

  constructor(organization: Organization) {
    this.id = organization.id;
    this.displayName = organization.display_name;
    this.pages = organization.metadata?.pages || [Routes.INCIDENTS, Routes.REPORTS];
    this.metadata = organization.metadata || {};
    this.branding = organization.branding;
  }

  isCopilotAvailable = ({ type }: { type: 'reports' | 'incidents' | 'geopolitical-actions' }) => {
    switch (type) {
      case 'incidents':
        return this.metadata?.incidents_copilot;
      case 'reports':
        return this.metadata?.reports_copilot;
      case 'geopolitical-actions':
        return this.metadata?.geopolitical_actions_copilot;
      default:
        return false;
    }
  };

  isDemoControlsAvailable = () => !!this.metadata?.incident_demo_control;

  /**
   * TODO: Move to metadata
   * Check if the organization supports streaming incidents.
   */
  isStreamingSupported = () => this.id === 'org_FF2peSjztb2dN6TQ';

  hasIncidentQueryLimit = () => Number.isInteger(this.metadata?.incidents_query_limit);
  getIncidentQueryLimit = () => this.metadata?.incidents_query_limit || null;
}
